var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy": "FormSoftSaleStockItem-customerCode",
                      label: "Select a Customer",
                      "item-text": "customerDesc",
                      "item-value": "customerCode",
                      items: _vm.customers,
                      multiple: "",
                    },
                    model: {
                      value: _vm.selectedCustomers,
                      callback: function ($$v) {
                        _vm.selectedCustomers = $$v
                      },
                      expression: "selectedCustomers",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "data-cy": "FormSoftSaleStockItem-itemCode",
                      label: _vm.$$t("itemCode"),
                      "item-text": (i) => `${i.itemCode} - ${i.description}`,
                      "item-value": "itemCode",
                      items: _vm.stockItems,
                      multiple: "",
                    },
                    model: {
                      value: _vm.selectedStockItems,
                      callback: function ($$v) {
                        _vm.selectedStockItems = $$v
                      },
                      expression: "selectedStockItems",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormSoftSaleStockItem-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormSoftSaleStockItem-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }